import { createTheme } from '@mui/material';

export const themeLight = createTheme({
  palette: {
    primary: {
      main: '#00A8F3',
      dark: '#03549A',
      light: '#B2E4FC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0F084B',
      dark: '#000025',
      light: '#402E78',
      contrastText: '#FFFFFF',
    },
    borderSelect: {
      main: '#C4C4C4',
    },
    error: {
      main: '#E23030',
      dark: '#B40D17',
      light: '#FECBD0',
    },
    success: {
      main: '#019E07',
      dark: '#005D00',
      light: '#C2E6BD',
    },
    warning: {
      main: '#FCC213',
      dark: '#FB7103',
      light: '#FEECB4',
    },
    text: {
      primary: '#000000',
      secondary: 'rgba(0, 0, 0, 0.5)',
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: '#FFFFFF',
          color: '#808080',
          '& .MuiChip-icon': {
            color: '#FFFFFF',
          },
          '&&:hover': {
            backgroundColor: '#00A8F3',
            color: '#FFFFFF',
            '& .MuiChip-icon': {
              color: '#FFFFFF',
            },
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        sx: { boxShadow: 'none' },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          wordBreak: 'break-word',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#808080',
          fontWeight: '400',
          padding: '8px',
          fontSize: '12px',
          backgroundColor: 'white',
          boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.1)',
        },
        arrow: {
          color: 'white',
        },
      },
    },
  },
});
